var map = {
	"./_privacy.json": 60839,
	"./about.json": 49740,
	"./accept-cookie.json": 12341,
	"./affiliate-terms.json": 39363,
	"./apps.json": 46807,
	"./common.json": 40464,
	"./contact-us.json": 1260,
	"./cookie-policy.json": 37731,
	"./customer-support.json": 84732,
	"./discord-email.json": 97771,
	"./discord-telegram-privacy.json": 95307,
	"./discord-telegram.json": 81165,
	"./footer.json": 65428,
	"./header.json": 1198,
	"./hire.json": 39171,
	"./home.json": 12482,
	"./privacy.json": 2297,
	"./reactFlow.json": 38547,
	"./recharge.json": 68274,
	"./selectors.json": 66122,
	"./suggestion.json": 87302,
	"./terms-of-use.json": 31475,
	"./training.json": 68007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97443;